const dsText = 'DESIGN SYSTEM';
const warnText = 'WARN';
const errorText = 'ERROR';

export const dsConsole = {
	warn: (...args) => console.warn(`${dsText}: ${warnText}:`, ...args),
	error: (...args) => console.error(`${dsText}: ${errorText}:`, ...args),
};
